
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RoundLoader extends Vue{
	@Prop({ default: 50 }) private size: number;
	@Prop({ default: 'baColorPrimaryBlue' }) private color: string;
}
